/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const GraphqlClubPageStyle = () => ({
    clubLander: {
        paddingBottom: '1px',
    },
});

export default GraphqlClubPageStyle;
